import { API_URL } from '../config/runtimeConfig';

const GOOGLE_CREDENTIAL_HASH_KEY = 'googleCredential';
const GOOGLE_AUTH_ERROR_HASH_KEY = 'googleAuthError';
const LOCAL_DEV_HOSTS = new Set(['localhost', '127.0.0.1']);

/** Production store hosts use API OAuth redirect; localhost keeps inline GIS. */
export const shouldUseOAuthRedirect = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return !LOCAL_DEV_HOSTS.has(window.location.hostname.toLowerCase());
};

export const buildGoogleOAuthStartUrl = (returnUrl, language) => {
  const url = new URL(`${API_URL}/auth/google/oauth/start`);
  url.searchParams.set('returnUrl', returnUrl || window.location.href);
  if (language != null) {
    url.searchParams.set('language', String(language));
  }
  return url.toString();
};

export const consumeGoogleCredentialFromHash = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) {
    return null;
  }

  const params = new URLSearchParams(hash);
  const credential = params.get(GOOGLE_CREDENTIAL_HASH_KEY);
  if (!credential) {
    return null;
  }

  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
  return credential;
};

export const consumeGoogleAuthErrorFromHash = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) {
    return null;
  }

  const params = new URLSearchParams(hash);
  const errorCode = params.get(GOOGLE_AUTH_ERROR_HASH_KEY);
  if (!errorCode) {
    return null;
  }

  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
  return errorCode;
};
